export const GET_FORM_DETAILS = "GET_FORM_DETAILS";
export const RESET_FORM_DATA = "RESET_FORM_DATA"
export const START_LOADING_FORM_DETAILS = "START_LOADING_FORM_DETAILS";
export const STOP_LOADING_FORM_DETAILS = "STOP_LOADING_FORM_DETAILS";
export const ERROR_LOADING_FORM_DETAILS = "ERROR_LOADING_FORM_DETAILS";